export const POS_DEFAULT_OPTION = {
	value: 'ALL',
	label: 'All POS'
}
